import CallableTextArea from "Components/Shared/CallableTextArea";
import { Field, Formik } from "formik";
import useCheckRole from "Hooks/APICheckRole";
import { useDDI } from "Hooks/Endpoints";
import { isEmpty } from "lodash";
import React from "react";
import {
  Breadcrumb,
  Button,
  Form,
  Header,
  Menu,
  Message,
} from "semantic-ui-react";
import { object, string } from "yup";

const InboundNumber = () => {
  const { ddi, unselect, release, isMBN, isAttached } = useDDI();
  const { hasRole, roles } = useCheckRole();

  return (
    <div>
      <Menu stackable>
        <Menu.Item>
          <Breadcrumb>
            <Breadcrumb.Section link onClick={() => unselect()}>
              Inbound Numbers
            </Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section>{ddi.name}</Breadcrumb.Section>
          </Breadcrumb>
        </Menu.Item>
      </Menu>
      <Message info>
        DDIs are only chargeable when attached to a call flow. However, if you
        would like to permanently cease the number, please raise a ticket below.
        <br />
        <br />
        If you are looking to export the number, please request an import with
        your new provider first which will automatically raise an export request
        within our system.
      </Message>

      {isMBN() && (
        <Message error>
          Looks like you are trying to release the main billing number of the
          account. Change the main billing number or if this is the last number
          on the account, simply delete the account.
        </Message>
      )}

      {isAttached() && (
        <Message error>
          The number is still attached to an inbound flow. Please unattach
          before attempting to release.
        </Message>
      )}
      <br />
      <Formik
        initialValues={{ ddi: ddi, reason: "" }}
        validationSchema={object().shape({
          ddi: object().required(),
          reason: string().required(),
        })}
        onSubmit={(values, actions) => {
          release(values);
        }}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <Header as='h2'>Release Request</Header>

            <Field
              name='reason'
              label='Cease Reason'
              component={CallableTextArea}
            />

            <Button
              primary
              type='submit'
              disabled={
                !hasRole(roles.account.device.ddi.roles.release) ||
                isAttached() ||
                isMBN() ||
                !isEmpty(props.errors)
              }
            >
              Request Release
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default InboundNumber;
